import {
  Button,
  Container,
  Group,
  Text,
  Title,
  useComputedColorScheme,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React from "react";
import { useAppSelector } from "../../app/hooks";
import { CardsCarousel } from "./CardsCarousel";
import AlbumDetail from "./AlbumDetail";
import "./AlbumList.css";
import { useNavigate } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";

interface CardProps {
  album: { id: string; name: string; coverImageUrl: string };
}

function Card({ album }: CardProps) {
  const navigate = useNavigate();
  const isMobile = useMediaQuery(
    `(max-width: ${useMantineTheme().breakpoints.xs})`
  );

  //return <div className="border border-red-500">Test</div>

  // New version
  return (
    <div
      className="w-full h-full rounded-lg overflow-hidden cursor-pointer min-h-[20rem] flex flex-col relative album-card"
      onClick={() => navigate(`/albums/${album.id}`)}
    >
      <div
        style={{
          backgroundImage: `url(${album.coverImageUrl})`,
          backgroundSize: "cover",
        }}
        className="w-full h-full flex-1 absolute album-cover-image"
      ></div>
      <div className="w-full absolute bottom-0 bg-[#000000ae] album-info">
        <div className="flex flex-col p-4">
          <Text className={"text-lg font-bold"}>{album.name}</Text>

          <Text fz="sm" c="dimmed">
            {album["description"] ?? ""}
          </Text>

          <Text fz="sm" c="dimmed">
            August 2025
          </Text>

          <Text fz="sm" c="dimmed">
            <ReactCountryFlag
              style={{ fontFamily: "Twemoji Country Flags" }}
              countryCode={"PL"}
              className="mr-2"
            ></ReactCountryFlag>
            {"Lesser Poland, Poland"}
          </Text>
        </div>
      </div>
    </div>
  );

  // Original version
  return (
    <div
      className={
        "h-[20rem] w-[15rem] rounded-lg flex flex-col justify-between" +
        (isMobile ? " w-full h-[30rem]" : "")
      }
    >
      <div
        style={{
          backgroundImage: `url(${album.coverImageUrl})`,
          backgroundSize: "cover",
        }}
        className="w-full h-full rounded-sm"
      >
        <div
          className="h-full card-text-shadow-top cursor-pointer"
          onClick={() => navigate(`/albums/${album.id}`)}
        >
          <div className="flex flex-col p-8">
            <Title order={3} className={"title"}>
              {album.name}
            </Title>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AlbumList() {
  const albumsState = useAppSelector((state) => state.albums);
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  return (
    <Container
      className="w-full mx-auto flex flex-col gap-4"
      p={isMobile ? "md" : "xl"}
      maw={"70rem"}
    >
      {albumsState.albums.length === 0 && (
        <div className="w-full h-full flex items-center justify-center">
          <Text fz="md" c="dimmed">
            No albums found
          </Text>
        </div>
      )}

      {albumsState.albums.length !== 0 && (
        <div className={isMobile ? "w-full" : ""}>
          <div className="flex flex-row flex-wrap gap-4 overflow-hidden album-cards-container">
            {albumsState.albums.map((album) => (
              <Card album={album} />
            ))}
          </div>
        </div>
      )}
    </Container>
  );
}
